import { lazy, type ReactNode, useEffect } from 'react';
import { captureEvent, DEPLOY_ENVIRONMENT, FRESH_ATS_FLAG, isPostHogEnabled, useSettledFeatureFlag } from '@/posthog-analytics/posthog';

const FreshAtsApp = lazy(() => import('../ats/AtsApp'));
const LegacyAtsApp = lazy(() => import('../new-ats/AtsApp'));

// QA and local don't run PostHog, so tenants there default to the Fresh ATS.
const isFreshAtsForEveryTenant = !isPostHogEnabled;

export function AtsSwitch({ fallback }: { fallback: ReactNode }) {
  const isFlagOn = useSettledFeatureFlag(FRESH_ATS_FLAG, { skip: isFreshAtsForEveryTenant });
  const showsFreshAts = isFreshAtsForEveryTenant ? true : isFlagOn;

  useEffect(() => {
    if (showsFreshAts === undefined) return;
    captureEvent('ats_version_served', { version: showsFreshAts ? 'fresh' : 'legacy', environment: DEPLOY_ENVIRONMENT });
  }, [showsFreshAts]);

  if (showsFreshAts === undefined) return <>{fallback}</>;
  return showsFreshAts ? <FreshAtsApp /> : <LegacyAtsApp />;
}
